<template>
  <slot />
</template>

<script setup lang="ts">
import { serializeJsonLd } from "@/shared/utils/jsonLdSerialize";

interface JsonLDCollectionItem {
  name?: string;
  url?: string;
  image?: string;
}

interface JsonLDCollectionOptions {
  name?: string;
  description?: string;
  url?: string;
  numberOfItems?: number;
  items?: JsonLDCollectionItem[];
  itemType?: string;
}

const props = defineProps<{ jsonOptions: JsonLDCollectionOptions }>();

useHead(() => {
  const o = props.jsonOptions;
  const items = o.items ?? [];

  return {
    script: [
      {
        type: "application/ld+json",
        innerHTML: serializeJsonLd({
          "@context": "https://schema.org",
          "@type": "CollectionPage",
          name: o.name ?? "",
          description: o.description ?? "",
          url: o.url ?? "",
          mainEntity: {
            "@type": "ItemList",
            numberOfItems: o.numberOfItems ?? "",
            itemListElement: items.map((it, i) => ({
              "@type": "ListItem",
              position: i + 1,
              item: {
                "@type": o.itemType ?? "Person",
                name: it.name ?? "",
                url: it.url ?? "",
                image: it.image ?? "",
              },
            })),
          },
        }),
      },
    ],
  };
});
</script>

<style scoped></style>
